import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { AppointmentStatus } from './appointment-status.interface';
export class AppointmentStatusService {
   async getAppointmentStatuses(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<AppointmentStatus>>>(`/appointment-statuses`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getAppointmentStatus() {
      throw Error('Method not implemented');
   }

   async postAppointmentStatus() {
      throw Error('Method not implemented');
   }

   async putAppointmentStatus() {
      throw Error('Method not implemented');
   }

   async deleteAppointmentStatus() {
      throw Error('Method not implemented');
   }
}
